import { makeStyles } from "@material-ui/core/styles";

/**
 * スタイルHook.
 */
const useStyles = makeStyles((theme) => ({
  dateFiled: {
    width: 300,
    margin: theme.spacing(0, 5, 2, 0),
  },
  textFiled: {
    width: 300,
  },
}));

export default useStyles;
